import { type AppNode, type ImageNodeData, type TextNodeData } from '../../types';
import { getImageNodeData } from '../../utils/getImageNodeData';
import { getTextNodeData } from '../../utils/getTextNodeData';
import { getVideoNodeData } from '../../utils/getVideoNodeData';

const MAX_TEXT_LENGTH = 50;

export type NodeSyncData = ImageNodeData | TextNodeData | NonNullable<ReturnType<typeof getVideoNodeData>>;

export function getNodeData(node: AppNode): { data: NodeSyncData; name: string } | undefined {
  const imageData = getImageNodeData(node);

  if (imageData) {
    return { data: imageData, name: imageData.fileName };
  }

  const videoData = getVideoNodeData(node);

  if (videoData) {
    return { data: videoData, name: videoData.fileName };
  }

  const textData = getTextNodeData(node);

  if (textData) {
    return { data: textData, name: textData.text.slice(0, MAX_TEXT_LENGTH) || 'Text' };
  }

  return undefined;
}
